import { Modal, message } from 'antd';
import { videoSourceService } from '../service/videoSourceService';

export type VideoSourceODKHandlersProps = {
  id: string;
  startFromBeginning: boolean;
  setLoading: (loading: boolean) => void;
};

export type VideoSourceODKHandlersReturn = {
  handleOnClickForceRefresh: () => void;
  handleOnClickBulkRefresh: () => void;
};

export const getVideoSourceODKHandlers = ({
  id,
  startFromBeginning,
  setLoading,
}: VideoSourceODKHandlersProps): VideoSourceODKHandlersReturn => {
  const handleOnClickForceRefresh = async (): Promise<void> => {
    Modal.confirm({
      title: 'Are you sure you want to force refresh?',
      onOk: async () => {
        setLoading(true);
        try {
          await videoSourceService.generate(Number(id));
          message.success('Force refresh success');
        } catch (error) {
          console.error('Force refresh failed:', error);
        }
        setLoading(false);
      },
    });
  };

  const handleOnClickBulkRefresh = async (): Promise<void> => {
    setLoading(true);
    try {
      await videoSourceService.bulkOdkSync(startFromBeginning);
      message.success('Bulk refresh success');
    } catch (error) {
      console.error('Bulk refresh failed:', error);
    }
    setLoading(false);
  };

  return {
    handleOnClickForceRefresh,
    handleOnClickBulkRefresh,
  };
};
